import { ConnectedRouter, routerMiddleware, connectRouter } from "connected-react-router";
import { createBrowserHistory } from "history";


const history = createBrowserHistory();

export default history;
